import React from "react";
export default React.createContext({
   user: {},
   facilityAccess: false,
   fieldAccess: false,
   wellAccess: false,
   wasteStorageAccess: false,
   signOut: () => {},
});
